import React, { useContext } from 'react';

import { Link } from '@amzn/awsui-components-react-v3';

import { AppContext } from '../../store/appContext';
import { AsyncState, Serial } from '../../store/types';
import { getMobilityUrl } from '../Utils/Utils';

export interface SerialNumberProps {
  serial: Serial;
  disabled: boolean;
  link?: boolean;
}

export const SerialNumber = ({ serial, disabled, link = true }: SerialNumberProps) => {
  const appContext = useContext(AppContext);
  const serialNumber = serial?.siteSpecificSerialId || serial?.serialNumber;
  if (disabled && serial.receiveStatus?.receiveStatusType !== AsyncState.ERROR && link) {
    return (
      <Link
        target="_blank"
        href={`${getMobilityUrl(
          appContext.appType,
        )}search_type=serial_id&search_string=${serialNumber}&max_rows=50&query=GO`}
      >
        {serialNumber}
      </Link>
    );
  }

  return serialNumber;
};
